export const RISK_REVIEW_COLUMNS = [
    {
        field: 'userName',
        headerName: 'Reported By',
        width: 350,
    },
    {
        field: 'teamName',
        headerName: 'Team Name',
        width: 350,
    },
    {
        field: 'address',
        headerName: 'Address',
        width: 350,
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 350,
    },
    {
        field: 'initiatedAt',
        headerName: 'Date Created',
        width: 350,
    },
];
